import { DateTime } from "luxon";
import "../../style/scss/App.scss";

export default function CertificationListItem({ certification, onEdit }) {
  const cert = certification || {};
  const id = cert.ID || cert.id;
  const date = cert.DateReceived
    ? DateTime.fromISO(cert.DateReceived).toFormat("MM/yyyy")
    : "";

  return (
    <li key={id}>
      <button
        type="button"
        className="centered skillLink location-list-item"
        data-testid={`certification-list-item-${id}`}
        onClick={() => onEdit?.(id)}
      >
        <div className="Certification mobilePanel">
          <span className="title">{cert.Name || "Certification"}</span>
          <span className="byline">
            {cert.OrganizationName || ""}
            {date ? ` · ${date}` : ""}
          </span>
        </div>
      </button>
    </li>
  );
}
